<template>
  <div id="profiles-main-container" class="profiles-main-container">
    <router-view />
  </div>
</template>

<script>
export default {
  name: "App",
}
</script>

<style lang="scss">
body {
  background: #f7f7f7;
}
.profiles-main-container {
  width: 100%;
  max-width: 1360px;
  position: relative;
  margin: 0 auto;
  padding: 25px 15px 60px;
}
.p-dialog {
  width: 380px;
  .p-dialog-header {
    justify-content: flex-end;
    padding: 9px;
    background: #4CCC52;
    .dialog-title {
      position: absolute;
      left: 50%;
      transform: translate(-50%);
      font-weight: 400;
      font-size: 16px;
      line-height: 22px;
      text-transform: uppercase;
      color: #FFFFFF;
    }
    .close-icon {
      bottom: 0;
      &:after,
      &:before {
        background: #ffffff;
      }
      &:hover:after,
      &:hover:before {
        background: #f7f7f7;
      }
    }
  }
  .p-dialog-content {
    padding: 70px 50px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .dialog-image {
      margin-bottom: 24px;
    }
    .dialog-text {
      text-align: center;
      font-width: 400;
      font-size: 17px;
      line-height: 23px;
      color: #545454;
    }
  }
  .p-dialog-footer {
    display: flex;
    gap: 18px;
    padding: 0 18px 40px;
    button {
      flex: 1 1 auto;
      margin: unset;
      font-size: 16px !important;
      line-height: 22px !important;
    }
  }
}

.p-toast {
  width: 100%;
  .p-toast-message-content {
    align-items: center;
  }
  .p-toast-message-icon {
    display: none;
  }
  .p-toast-message-text {
    align-self: end;
    justify-content: center;
    display: flex;
  }
  .p-toast-icon-close {
    display: none;
  }
}
.p-toast-top-right {
  top: 0;
  right: 0;
}
.p-toast .p-toast-message.p-toast-message-error {
  border: none;
  background: #ffd9d9;
  color: #4d4d4d;
}
.p-toast .p-toast-message .p-toast-message-content .p-toast-summary {
  font-weight: 500;
  line-height: 22px;
}
.p-toast .p-toast-message .p-toast-message-content {
  padding: 25px;
}
</style>
